import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { SelectOption } from 'types/base';
import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import LOCALS from 'commons/locals';
import { Checkbox } from 'antd';
import { FormLabel } from '../form-label';
import i18n from 'i18n';

const ProductAccessory = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const { accessorySelectOptions } = useAppSelector(selectGlobalInfo);
  const accessoryListSort = useMemo((): SelectOption[] => {
    if (accessorySelectOptions && accessorySelectOptions.length) {
      return [...accessorySelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [accessorySelectOptions]);

  return (
    <div className="flex items-center gap-2">
      <FormLabel className="basis-[12.5%]">
        {i18n.t(LOCALS.accessories)}:
      </FormLabel>
      <Controller
        name="accessory"
        control={control}
        render={({ field }) => (
          <Checkbox.Group options={accessoryListSort} {...field} />
        )}
      />
    </div>
  );
};

export default ProductAccessory;
